/*
 * mesesCliente.js — Lógica pura de la pestaña Resumen de la ficha (C-023, ver diseno/CAMBIOS.md).
 *
 * "El año, mes por mes": 12 cuadros con ✓ si el mes terminó, el paso donde se detuvo o su atraso,
 * y punteados los meses que todavía no se trabajan. Usa la misma regla de paso actual que la
 * tabla mensual (C-003), así los números coinciden.
 */
import { calcularPasoActual, pasosCascada } from './estados';

export const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

/** Un mes "todavía no se trabaja" si es posterior al mes en curso (el de trabajo es el anterior). */
export const esMesFuturo = (mes, anio, hoy = new Date()) =>
  anio * 12 + (mes - 1) >= hoy.getFullYear() * 12 + hoy.getMonth();

/**
 * Estado de un mes para un cliente: { futuro, terminado, corto (paso donde se detuvo), dias }.
 * `estados`: filas { proceso_id, estado } de ese mes (de la tabla o de /estados-anio).
 */
export const resumenDeMes = ({ estados, procesos, fechasLimite, mes, anio, revision_pedro = 'no' }, hoy = new Date()) => {
  if (esMesFuturo(mes, anio, hoy)) return { futuro: true, terminado: false, corto: null, dias: 0 };
  const cliente = { estados: estados || [], revision_pedro };
  const actual = calcularPasoActual(cliente, procesos, fechasLimite, { mes, anio }, hoy);
  if (!actual) return { futuro: false, terminado: true, corto: null, dias: 0 };
  const paso = pasosCascada(procesos).find(p => p.proceso.id === actual.proceso.id);
  return { futuro: false, terminado: false, corto: paso ? paso.corto : actual.proceso.nombre, dias: actual.diasAtraso };
};

/** Los 12 meses de un año, a partir de las filas { mes, proceso_id, estado } del año. */
export const resumenDelAnio = ({ filas, procesos, fechasLimite, anio, revision_pedro }, hoy = new Date()) =>
  MESES_CORTOS.map((corto, i) => ({
    mes: i + 1,
    nombre: corto,
    ...resumenDeMes({
      estados: (filas || []).filter(f => Number(f.mes) === i + 1), procesos, fechasLimite, mes: i + 1, anio, revision_pedro,
    }, hoy),
  }));
